import React from 'react';
import { UserAvatar } from '@/components/ui/enhanced-avatar';

export const AvatarTest: React.FC = () => {
  const testCases = [
    {
      title: "With Profile Image",
      src: "https://github.com/shadcn.png",
      value: "john.doe@example.com",
      firstName: "John",
      lastName: "Doe"
    },
    {
      title: "No Image - Character Style",
      src: undefined,
      value: "jane.smith@example.com",
      firstName: "Jane",
      lastName: "Smith",
      style: "character" as const
    },
    {
      title: "No Image - Shape Style", 
      src: undefined,
      value: "bob.wilson@example.com",
      firstName: "Bob",
      lastName: "Wilson",
      style: "shape" as const
    },
    {
      title: "Traditional Fallback (JS)",
      src: undefined,
      value: "test@example.com",
      firstName: "Test",
      lastName: "User",
      disableAvvvatars: true
    },
    {
      title: "Single Name (AS)",
      src: undefined,
      value: "alice@example.com",
      firstName: "Alice",
      lastName: undefined,
      style: "character" as const
    }
  ];

  return (
    <div className="p-8 space-y-8">
      <h1 className="text-2xl font-bold">Avatar Test Cases</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
        {testCases.map((testCase, index) => (
          <div key={index} className="flex flex-col items-center space-y-4">
            <h3 className="text-sm font-medium text-center">{testCase.title}</h3>
            
            {/* Small size */}
            <div className="flex flex-col items-center space-y-2">
              <span className="text-xs text-gray-500">Small (32px)</span>
              <UserAvatar
                src={testCase.src}
                value={testCase.value}
                firstName={testCase.firstName}
                lastName={testCase.lastName}
                style={testCase.style}
                disableAvvvatars={testCase.disableAvvvatars}
                className="h-8 w-8"
              />
            </div>
            
            {/* Medium size */}
            <div className="flex flex-col items-center space-y-2">
              <span className="text-xs text-gray-500">Medium (48px)</span>
              <UserAvatar
                src={testCase.src}
                value={testCase.value}
                firstName={testCase.firstName}
                lastName={testCase.lastName}
                style={testCase.style}
                disableAvvvatars={testCase.disableAvvvatars}
                className="h-12 w-12"
              />
            </div>
            
            {/* Large size */}
            <div className="flex flex-col items-center space-y-2">
              <span className="text-xs text-gray-500">Large (96px)</span>
              <UserAvatar
                src={testCase.src}
                value={testCase.value}
                firstName={testCase.firstName}
                lastName={testCase.lastName}
                style={testCase.style}
                disableAvvvatars={testCase.disableAvvvatars}
                className="h-24 w-24 text-2xl"
              />
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-8 p-4 bg-gray-50 rounded-lg">
        <h3 className="font-medium mb-2">Test Instructions:</h3>
        <ul className="text-sm text-gray-600 space-y-1">
          <li>• First column: Profile image (JD initials when hovered)</li>
          <li>• Second column: Avvvatars character style (JS initials)</li>
          <li>• Third column: Avvvatars shape style (BW initials)</li>
          <li>• Fourth column: Traditional text fallback (TU initials)</li>
          <li>• Fifth column: Single name handling (A? initials)</li>
          <li>• Each avatar generates unique visuals based on the email value</li>
          <li>• Initials are auto-generated from firstName + lastName</li>
        </ul>
      </div>
    </div>
  );
};